import React from 'react';

const JobApply = React.lazy(() => import('./JobApply'));

export default JobApply;
